import { css } from '@emotion/react';
import { TextBody2RRMixin } from '@mobalytics/shared';
import { Price } from '../../../../payment/payment-details/plan-details/total-price/price/price.component';

interface Props {
  className?: string;
  label: string;
  priceAmount: number;
  priceCurrency: string;
}

export const CheckoutPrice: React.FC<Props> = (props) => {
  const { priceAmount, priceCurrency, label, className } = props;
  return (
    <div css={wrapper} className={className}>
      <span css={labelCss}>{label}:</span> <Price value={priceAmount} currency={priceCurrency} />
    </div>
  );
};

const labelCss = css`
  ${TextBody2RRMixin};
`;

const wrapper = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
`;
